import { shallowEqual, useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useOnboardingTabStatuses() {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.tabStatuses,
    shallowEqual,
  );
}
